<template>
  <div class="kd2-chart-wrap">
    <div class="history-tabs">
      <button v-for="(tab, i) in tabs" :key="i" class="history-tab" :class="tab.active ? 'history-tab--active' : ''"
        @click="gethistory(tab.tnum, tab.tunit, i)">{{ tab.label }}</button>
    </div>
    <div class="chart-card">
      <div id="tempChartKD2" class="history-chart"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TempChartKD2",
  props: ["did"],
  data() {
    return {
      tabs: [
        { label: "1小时", tnum: 1, tunit: "hour", active: true },
        { label: "6小时", tnum: 6, tunit: "hour", active: false },
        { label: "1天", tnum: 1, tunit: "day", active: false },
        { label: "1周", tnum: 7, tunit: "day", active: false },
      ],
      templist: [],
      temptimelist: [],
    };
  },
  mounted() {
    this.gethistory(1, "hour", 0);
  },
  methods: {
    gethistory(tnum, tunit, idx) {
      for (var i = 0; i < this.tabs.length; i++) {
        this.tabs[i].active = i === idx;
      }
      this.templist = [];
      this.temptimelist = [];
      const qs = require("qs");
      this.$axios
        .post("/api/dev/kd1/history", qs.stringify({ did: this.did, tnum: tnum, tunit: tunit }))
        .then((response) => {
          if (response.data.error_code === 0) {
            for (var row of response.data.data.temp_buf) {
              this.templist.push(row.v);
              this.temptimelist.push(row.t);
            }
            this.drawtempLine();
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        });
    },
    drawtempLine() {
      this.$nextTick(() => {
        var chartDom = document.getElementById("tempChartKD2");
        if (!chartDom) return;
        let volChart = echarts.init(chartDom);
        var option = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.95)",
            borderColor: "#e2e8f0",
            borderWidth: 1,
            textStyle: { color: "#475569", fontSize: 12, fontFamily: "Inter, Noto Sans SC, sans-serif" },
            formatter: function (params) {
              return '<div style="font-weight:600;color:#1e293b;font-size:13px;margin-bottom:4px">' + params[0].axisValue + '</div>' +
                '<div style="display:flex;align-items:center;gap:6px;padding:2px 0">' +
                '<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#2dd4bf"></span>' +
                '<span style="color:#64748b">' + params[0].seriesName + '：</span>' +
                '<span style="color:#1e293b;font-weight:600">' + params[0].value + '℃</span></div>';
            }
          },
          grid: { left: "8%", right: "8%", top: "8%", bottom: "18%" },
          xAxis: {
            type: "category", data: this.temptimelist,
            axisLine: { lineStyle: { color: "#e2e8f0" } },
            axisTick: { show: false },
            axisLabel: { color: "#94a3b8", fontSize: 10, fontWeight: 400 },
            splitLine: { show: false },
          },
          yAxis: {
            type: "value",
            name: "温度/℃",
            nameTextStyle: { color: "#94a3b8" },
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: { color: "#94a3b8", fontSize: 10, fontWeight: 400 },
            splitLine: { lineStyle: { color: "#f1f5f9", type: "dashed" } },
          },
          dataZoom: [{
            type: "slider", start: 0, end: 100,
            height: 24, bottom: 24,
            borderColor: "#e2e8f0", backgroundColor: "#f8fafc",
            fillerColor: "rgba(45,212,191,0.1)",
            handleStyle: { color: "#2dd4bf" },
            textStyle: { color: "#94a3b8", fontSize: 10 },
          }],
          series: {
            name: "温度",
            data: this.templist,
            type: "line",
            symbol: "none",
            smooth: true,
            lineStyle: { color: "#2dd4bf", width: 2 },
            areaStyle: { color: "rgba(45,212,191,0.06)" },
            itemStyle: { color: "#2dd4bf" },
          },
        };
        volChart.setOption(option);
      });
    },
  },
};
</script>

<style scoped>
.kd2-chart-wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.history-tabs {
  display: flex;
  gap: 8px;
  justify-content: center;
  padding: 0 4px;
}

.history-tab {
  flex: 1;
  height: 32px;
  padding: 0 4px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.2s;
  white-space: nowrap;
  text-align: center;
}

.history-tab--active {
  background: #2dd4bf;
  color: #fff;
}

.history-tab:not(.history-tab--active) {
  background: #f1f5f9;
  color: #94a3b8;
}

.history-tab:not(.history-tab--active):active {
  background: #e2e8f0;
}

.chart-card {
  background: #ffffff;
  border-radius: 18px;
  padding: 12px 8px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
}

.history-chart {
  height: 280px;
  width: 100%;
}
</style>
